export enum DOCUMENT_CATEGORY {
  COMPLIANCE_DOCUMENTS = 'COMPLIANCE_DOCUMENTS',
  PURCHASE_AGREEMENTS = 'PURCHASE_AGREEMENTS',
  CLAIM_AGREEMENTS = 'CLAIM_AGREEMENTS',
  PRIVACY_DOCUMENTS = 'PRIVACY_DOCUMENTS',
}
